<template>
    <label class="custom-upload">
        <slot></slot>
        <input
            ref="uploadInput"
            :name="name"
            accept="image/jpg, image/jpeg, image/png, image/svg+xml"
            class="d-none"
            type="file"
            @change="selectFile"
        />
        <a-modal v-if="isShowModal" v-model:open="isShowModal" :maskClosable="false" title="Crop Image" @ok="getResult">
            <VuePictureCropper
                :boxStyle="{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#f8f8f8',
                    margin: 'auto',
                }"
                :img="pic"
                :options="{
                    viewMode: 1,
                    dragMode: 'crop',
                    aspectRatio: aspectRatio,
                }"
            />
        </a-modal>
    </label>
</template>

<script>
import VuePictureCropper, {cropper} from 'vue-picture-cropper'
import {MAX_SIZE_IMAGE_TENANT_UPLOAD} from "../../const";

export default {
    components: {
        VuePictureCropper,
    },
    props: {
        modelValue: Blob | String, // v-model for the cropped image result
        name: {
            type: String,
            default: 'image',
        },
        aspectRatio: {
            type: Number,
            default: 1,
        },
        base64String: {
            type: String,
            default: '',
        },
        base64Image: {
            type: String,
            default: '',
        },
        messErrorTenantLogo: {
            type: String,
            default: ''
        },
        messErrorTenantImage: {
            type: String,
            default: ''
        },
        uploadTenantLogo: {
            type: Boolean,
            default: false
        },
        uploadTenantImage: {
            type: Boolean,
            default: false
        },
        isChangeTenantLogo: {
          type: Boolean,
          default: false
        },
        isChangeTenantImage: {
          type: Boolean,
          default: false
        },
        open: {
          type: Boolean,
          default: false
        }
    },
    data() {
        return {
            isShowModal: false,
            pic: '',
        };
    },
    methods: {
        selectFile(e) {
            // Reset last selection and results
            this.pic = ''
            var filePath = e.target.files;
            var file = filePath[0];
            var imageReg = /[\/.](jpg|jpeg|png|svg|JPEG|JPG|PNG|SVG)$/i
            if (filePath.length !== 0) {
                let fileName = file.name;

                if (!imageReg.test(fileName)) {
                    if (this.uploadTenantLogo) {
                        this.$emit('update:messErrorTenantLogo', 'Uploaded file is not in the correct format')
                    } else {
                        this.$emit('update:messErrorTenantImage', 'Uploaded file is not in the correct format')
                    }

                    this.$emit('update:open', true)
                } else if ((file.size / (1024 * 1024)) > MAX_SIZE_IMAGE_TENANT_UPLOAD) {
                    if (this.uploadTenantLogo) {
                        this.$emit('update:messErrorTenantLogo', `Maximum file upload size exceeded (${MAX_SIZE_IMAGE_TENANT_UPLOAD} MB)`)
                    } else {
                        this.$emit('update:messErrorTenantImage', `Maximum file upload size exceeded (${MAX_SIZE_IMAGE_TENANT_UPLOAD} MB)`)
                    }

                  this.$emit('update:open', true)
                } else {
                    const reader = new FileReader()
                    reader.readAsDataURL(file)
                    reader.onload = () => {
                        // Update the picture source of the `img` prop
                        this.pic = String(reader.result)

                        // Show the modal
                        this.isShowModal = true

                        // Clear selected files of input element
                        if (!this.$refs.uploadInput) return
                        this.$refs.uploadInput.value = null
                    }
                }
            }
        },

        /**
         * Get cropping results
         */
        async getResult() {
            if (!cropper) return
            const base64 = cropper.getDataURL()
            const blob = await cropper.getBlob()
            if (!blob) return
            // Update the v-model
            this.isShowModal = false
            this.$emit('update:modelValue', blob)
            this.$emit('update:base64String', base64)
            this.$emit('update:base64StringImage', this.pic)
            this.$emit('update:isChangeTenantLogo', true)
            this.$emit('update:isChangeTenantImage', true)

            if (this.uploadTenantLogo) {
              this.$emit('update:messErrorTenantLogo', '')
            } else {
              this.$emit('update:messErrorTenantImage', '')
            }

        },
    },
};
</script>
